import { BackButton, PencilIcon } from "@mwi/ui";

import PetNamePill from "../../components/PetNamePill";
import DateItem from "../../components/DateItem";

const MessagesHeader = ({
  conversation,
}: {
  conversation: any;
}): JSX.Element => {
  return (
    <div className="flex-grow-0 tablet:border-b tablet:border-grey-light pb-2 tablet:mb-6 py-4 mx-4">
      <div className="flex flex-row justify-between items-center mb-2">
        <div className="flex items-center gap-2 items-center">
          <BackButton
            className="tablet:hidden mr-2"
            to="/messages"
            variant="grey"
            data-test-id="Messages_BackButton"
          />

          <h2
            data-test-id="MessagesSection_Conversation_Title"
            className="text-xl font-semibold tablet:text-base tablet:font-medium overflow-hidden text-ellipsis whitespace"
          >
            {conversation.summary?.title}
          </h2>
          {conversation.summary?.pet?.map((pet) => (
            <PetNamePill
              data-test-id="MessagesSection_Conversation_PetName"
              petName={pet.name}
            />
          ))}
        </div>
        <DateItem
          data-test-id="MessagesSection_Conversation_LastUpdated"
          className="hidden tablet:flex"
          date={conversation.lastUpdated}
        />
      </div>
    </div>
  );
};

export default MessagesHeader;
